import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import { getFirestore } from 'firebase/firestore';

import FirebaseConfig from '../types/FirebaseConfig';

const config: FirebaseConfig = {
  apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY}`,
  authDomain: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseio.com`,
  projectId: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}`,
  storageBucket: `gs://${process.env.REACT_APP_FIREBASE_PROJECT_ID}`,
  messagingSenderId: `${process.env.REACT_APP_FIREBASE_SENDER_ID}`,
  appId: `${process.env.REACT_APP_FIREBASE_APP_ID}`,
  measurementId: `G-${process.env.REACT_APP_FIREBASE_MEASUREMENT_ID}`,
};

const firebaseApp = firebase.initializeApp(config);
const firebaseStorage = firebaseApp.storage();
const firestoreDb = firebaseApp.firestore();
const firestore = getFirestore(firebaseApp);

export { firebaseApp, firebaseStorage, firestoreDb, firestore as fbStorage };
